import styled, { css } from 'styled-components';

import { Label } from '@r1-frontend/ui-react/components/label';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Description from '~/src/features/_layout/Header/desktop/components/MainMenuItem/components/Description';

export const ItemWrapper = styled.div<{ isCurrent: boolean }>`
    max-height: 82px;
    min-width: 190px;
    width: max-content;
    padding: 6px 18px 12px;
    border-radius: ${BorderRadius.labelRadius};
    background-color: ${COLORS.BgMain};
    transition: background-color .25s;
    pointer-events: ${p => p.isCurrent ? 'none' : 'auto'};

    &:hover {
        background-color: ${COLORS.BgSurface};
    }
`;

export const TitleRow = styled.div<{ withLabel?: boolean }>`
    flex-direction: row;
    flex-wrap: nowrap;
    ${({ withLabel }) => withLabel && css`
        margin-bottom: 1px;
    `};
`;

export const SLabel = styled(Label)`
    margin-top: 2px;
    margin-left: 6px;
`;

export const SDescription = styled(Description)`
    width: 190px;
`;
